// Product categories for filtering
export enum ProductCategory {
  ALL = "all",
  FISH_SAUCE = "fish_sauce", 
  BEEF_DIP = "beef_dip",
  OTHER = "other"
}

// Shopping platform types
export enum ShoppingPlatform {
  SHOPEE = "shopee",
  LAZADA = "lazada", 
  TIKTOK = "tiktok",
  LINE = "line",
  FACEBOOK = "facebook"
}

// Contact form related enums
export enum ContactFormField {
  FULL_NAME = "fullName",
  PHONE = "phone", 
  EMAIL = "email",
  COUNTRY = "country",
  SUBJECT = "subject",
  MESSAGE = "message"
}

export enum CountryOption {
  THAILAND = "thailand",
  USA = "usa",
  UK = "uk",
  JAPAN = "japan",
  OTHER = "other"
}